import React from 'react';
import { TrendingUp, Mail, Phone, MapPin, Facebook, Twitter, Instagram, Youtube } from 'lucide-react';
import './Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    strategies: [
      { name: 'Options Strategies', href: '#strategies' },
      { name: 'FNO Trading', href: '#fno' },
      { name: 'Crypto Strategies', href: '#crypto' },
      { name: 'Capital Growth', href: '#growth' }
    ],
    markets: [
      { name: 'Indian Markets', href: '#indian-market' },
      { name: 'Global Markets', href: '#world-market' },
      { name: 'Cryptocurrency', href: '#crypto' },
      { name: 'FNO Analysis', href: '#fno' }
    ],
    resources: [
      { name: 'Market Analysis', href: '#blog' },
      { name: 'Strategy Insights', href: '#insights' },
      { name: 'Research Reports', href: '#research' },
      { name: 'Community Forum', href: '#forum' }
    ],
    community: [
      { name: 'Member Portal', href: '#portal' },
      { name: 'Strategy Sharing', href: '#sharing' },
      { name: 'Performance Tracking', href: '#tracking' },
      { name: 'Internal Tools', href: '#tools' }
    ]
  };

  const socialLinks = [
    { name: 'Facebook', icon: <Facebook size={20} />, href: 'https://facebook.com/agnialgo' },
    { name: 'Twitter', icon: <Twitter size={20} />, href: 'https://twitter.com/agnialog' },
    { name: 'Instagram', icon: <Instagram size={20} />, href: 'https://instagram.com/agnialgo' },
    { name: 'YouTube', icon: <Youtube size={20} />, href: 'https://youtube.com/@AgniAlgo' }
  ];

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-main">
            <div className="footer-brand">
              <div className="footer-logo">
                <TrendingUp className="logo-icon" />
                <span className="logo-text">Agni</span>
              </div>
              <p className="footer-description">
                Internal community platform for self-motivated individuals focused on options strategies, 
                FNO trading, and capital growth. Collaborative approach to market analysis and strategy development.
              </p>
              <div className="footer-contact">
                <div className="contact-item">
                  <Mail className="contact-icon" />
                  <span>agnialgo@gmail.com</span>
                </div>
                <div className="contact-item">
                  <Phone className="contact-icon" />
                  <span>+91 9845711525</span>
                </div>
                <div className="contact-item">
                  <MapPin className="contact-icon" />
                  <span>Mumbai, Maharashtra, India</span>
                </div>
              </div>
            </div>

            <div className="footer-links">
              <div className="link-group">
                <h4 className="link-title">Strategies</h4>
                <ul className="link-list">
                  {footerLinks.strategies.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} className="footer-link">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="link-group">
                <h4 className="link-title">Markets</h4>
                <ul className="link-list">
                  {footerLinks.markets.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} className="footer-link">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="link-group">
                <h4 className="link-title">Resources</h4>
                <ul className="link-list">
                  {footerLinks.resources.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} className="footer-link">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="link-group">
                <h4 className="link-title">Community</h4>
                <ul className="link-list">
                  {footerLinks.community.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} className="footer-link">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>

        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <div className="footer-copyright">
              <p>&copy; {currentYear} Agni. All rights reserved.</p>
            </div>
            
            <div className="footer-legal">
              <a href="#privacy" className="legal-link">Privacy Policy</a>
              <a href="#terms" className="legal-link">Terms of Service</a>
              <a href="#disclaimer" className="legal-link">Risk Disclaimer</a>
            </div>

            <div className="footer-social">
              {socialLinks.map((social, index) => (
                <a 
                  key={index}
                  href={social.href} 
                  className="social-link"
                  aria-label={social.name}
                >
                  {social.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
